<div class="tw-flex tw-flex-col tw-h-full tw-gap-2">
  <app-step-indicator [steps]="steps" [currentIndex]="currentIndex()"></app-step-indicator>

  <div appGlossScroll class="tw-flex-grow tw-min-h-0 tw-overflow-y-auto tw-p-1">
    <ng-container #stepContainer></ng-container>
  </div>
  <app-gloss-button [options]="nextBtnOptions" class="tw-p-1"></app-gloss-button>
</div>
